import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Elements/Modal/Modal";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import AffiliationModalStatus from "./AffiliationModalStatus";
import AffiliationService from "../../services/AffiliationService";
import "../AdminPages/AdminModalForm.css";

const AffiliationDeletePromocodeModal = ({ isOpen, onClose, promocode, onDeleted }) => {
  const { t } = useTranslation();
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleDelete = async () => {
    if (deleting || !promocode) return;

    try {
      setDeleting(true);
      setError("");
      await AffiliationService.deleteAffiliatePromocode(promocode.code);
      setSuccess(t("affiliation.promocodeDeletedSuccessfully", "Promocode deleted successfully."));
      onDeleted?.();
    } catch (requestError) {
      const detail = requestError.response?.data?.detail;
      setError(
        typeof detail === "string" ? detail : requestError.message || t("errors.generic", "Something went wrong"),
      );
    } finally {
      setDeleting(false);
    }
  };

  if (!isOpen || !promocode) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={deleting ? () => {} : onClose}
      title={t("affiliation.deletePromocode", "Delete Promocode")}
      actions={
        success ? (
          <MainButton onClick={onClose}>{t("common.close", "Close")}</MainButton>
        ) : (
          <>
            <SecondButton onClick={onClose} disabled={deleting}>
              {t("common.cancel", "Cancel")}
            </SecondButton>
            <MainButton onClick={handleDelete} disabled={deleting}>
              {deleting ? t("common.deleting", "Deleting...") : t("common.delete", "Delete")}
            </MainButton>
          </>
        )
      }
    >
      <div className="admin-modal-form">
        <p>
          {t("affiliation.confirmDeletePromocode", "Are you sure you want to delete this promocode?")}
          <br />
          <strong>{promocode.code}</strong>
        </p>
        <p>
          {t("affiliation.promocodeType", "Type")}: <strong>{promocode.type}</strong>
        </p>
        <p>{t("affiliation.deletePromocodeWarning", "This action cannot be undone.")}</p>
        <AffiliationModalStatus
          error={error}
          success={success}
          onErrorClose={() => setError("")}
          onSuccessClose={onClose}
        />
      </div>
    </Modal>
  );
};

export default AffiliationDeletePromocodeModal;
